function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstructionDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "construction_x5F_door",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 32",
    style: {
      enableBackground: "new 0 0 24 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "24,32 22,32 22,2 2,2 2,32 0,32 0,0 24,0  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M19,20c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S20.103,20,19,20z M19,17.999V18V17.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    style: {
      fill: "#FD5C3F"
    },
    width: 4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    style: {
      fill: "#FD5C3F"
    },
    width: 14,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionDoor);
export default __webpack_public_path__ + "static/media/construction_door.eda4ea4e9ce16eb02f7676df7aa612bc.svg";
export { ForwardRef as ReactComponent };